define(function(require, exports, module) {
    'use strict';

    var SuperForm = require('class/form.class');
    var infoTooltip = require('class/totalcasino-theme/infoTooltip.mixin');
    var Class = require('Class');
    var $ = require('j');

    var Form = Class.create(SuperForm, infoTooltip, {

        superClass: SuperForm.prototype,

        initialize: function($form) {
            this.superClass.initialize.apply(this, arguments);
            this.verifyFormElement($form);
        },

        wrapFormControl: function(element) {
            var parent = element.parentNode,
                type = element.type === 'select-one' ? 'select' : element.type,
                wrapper = document.createElement('span'),
                display = document.createElement('span'),
                wrapperClassName = 'js-' + type,
                displayClassName = 'js-' + type + '__display';

            this.$wrappedElements = $(element);

            if (element.parentNode.className === wrapperClassName) {
                return this;
            }

            wrapper.className = wrapperClassName;
            display.className = displayClassName;

            parent.insertBefore(wrapper, element);
            wrapper.appendChild(element);
            wrapper.appendChild(display);

            if (type === 'select' && element.options.length) {
                if (element.options.selectedIndex === 0 || element.options.selectedIndex === -1) {
                    display.textContent = element.options[0].text;

                    if (!element.options[0].value) {
                        element.classList.add('default');
                    }
                } else {
                    display.textContent = element.options[element.options.selectedIndex].text;
                }

                [].forEach.call(element.options, function(option) {
                    if (!option.value) {
                        option.disabled = true;
                        option.style.display = 'none';
                    }
                });

                this.$wrappedElements
                    .on('keyup', function() {
                        // Fix for change event in FF
                        element.blur();
                        element.focus();
                    })
                    .on('change input', Form.refreshSelectField.bind(null, element, display));
            }

            return this;
        },

        verifyFormElement: function($form) {
            if ($form && !$form.length) {
                throw new Error('No form element');
            }
        },

        delegateEvents: function() {
            var result = this.superClass.delegateEvents.apply(this, arguments);
            this.$elements
                .on('form:focusin.form', function(e) {
                    this.showInfoTooltipIfNecessary(e);
                }.bind(this))
                .on('form:focusout.form', this.removeInfoTooltip.bind(this));
            return result;
        }
    });

    Form.toggleLoading = SuperForm.toggleLoading;
    Form.refreshSelectField = SuperForm.refreshSelectField;
    Form.toggleFieldVisibility = SuperForm.toggleFieldVisibility;

    module.exports = Form;
});
